import React from 'react'
import OwlCarousel from 'react-owl-carousel';
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';

export default function TopAvatarsOnRent() {
  return (
    <div className="nft-wrapper py-5">
  <div className="container pb-lg-5">
    <div className="row justify-content-center">
      <div className="col-lg-8 text-center d-flex justify-content-center gap-2 pb-lg-5">
        <h2 className="text-gray-900 rajdhani-600 h1 mb-0 dark-text">Top Avatars on Rent</h2>
        <select className="nice-select rajdhani-600 h1 border-0 text-current-red bg-transparent mb-0 ps-2">
          <option data-display="1 day"> 7 Day's</option>
          <option value={2}>15 Day's</option>
          <option value={3}>30 Day's</option>
        </select>
      </div>
      <div className="col-12 d-flex gap-3" style={{marginTop: 20}}>
        <select className="form-select rounded-10 w-150 font-sm light-bg dark-border dark-text text-gray-900 rajdhani-600 bg-gray-100" aria-label="select example">
          <option value>Relavence</option>
          <option value={1}>High to Low</option>
          <option value={2}>Low to High</option>
          <option value={3}>Price</option>
        </select>
        <select className="form-select rounded-10 w-150 font-sm light-bg dark-border dark-text text-gray-900 rajdhani-600 bg-gray-100" aria-label="select example">
          <option value>Category</option>
          <option value={1}>High to Low</option>
          <option value={2}>Low to High</option>
          <option value={3}>Price</option>
        </select>
        <select className="form-select rounded-10 w-150 font-sm light-bg dark-border dark-text text-gray-900 rajdhani-600 bg-gray-100" aria-label="select example">
          <option value>Sort by</option>
          <option value={1}>High to Low</option>
          <option value={2}>Low to High</option>
          <option value={3}>Price</option>
        </select>
        <select className="form-select rounded-10 w-150 font-sm light-bg dark-border dark-text text-gray-900 rajdhani-600 bg-gray-100" aria-label="select example">
          <option value>On Sale</option>
          <option value={1}>High to Low</option>
          <option value={2}>Low to High</option>
          <option value={3}>Price</option>
        </select>
        <a href="#" className="ms-auto btn btn-md border rajdhani-600 text-gray-900 bg-gray-100 font-sm d-flex gap-2 dark-bg dark-text dark-border">Filter <i className="feather-filter font-xs" /></a>
      </div>
    </div>
    <div className="row mt-3">
      <div className="col-lg-4 col-md-4">
        <div className="nft-div border dark-bg3 rounded-10 dark-border p-2 mt-4">
          <div className="d-flex gap-2 p-1">
            <figure className="avater mb-0"><img src="images/artist-2.jpg" alt="user" className="w-35 rounded-pill" /></figure>
            <h5 className="rajdhani-600 text-gray-900 h6 dark-text d-flex lh-34 gap-1">@panditcoast <i className="bi-patch-check-fill font-sm text-success mt-1" /></h5>
            <i className="btn btn-icon btn-sm rounded-pill ms-auto dark-text dark-border m-0 border bi-three-dots font-sm" />
          </div>
          <div className="d-flex p-1 posr"><figure className="mb-0 w-100 rounded-10 h-250 bg-image-cover bg-no-repeat bg-image-center" style={{backgroundImage: 'url(images/avatar-1.jpeg)'}} />
          </div>
          <div className="d-flex mt-2 p-1">
            <h2 className="rajdhani-600 text-gray-900 dark-text h5">The Poser Party  <span className="font-xss d-block text-gray-500 rajdhani-600">@panditcoast</span></h2>
            <span className="ms-auto d-flex justify-content-center w-40 h-40 mt-1 bg-gray-100 border rounded-pill"><img src="images/icon-13.png" alt="img" className="w-26 my-auto" /></span>
          </div>
          <div className="d-flex justify-content-between p-1">
            <h6 className="text-start dark-text rajdhani-600"><span className="font-xss rajdhani-500 dark-text text-gray-500 d-block">Current price</span>0.987TRON</h6>
            <h6 className="text-center dark-text rajdhani-600"><span className="font-xss rajdhani-500 text-gray-500 d-block">Floor price</span>2.27TRON</h6>
            <h6 className="text-end dark-text rajdhani-600"><span className="font-xss rajdhani-500 text-gray-500 d-block">Current Bid</span>1.73TRON</h6>
          </div>
          <div className="d-flex p-1">
            <a href="#" className="btn btn-lg btn-block lh-18 rajdhani-600 text-gray-900 font-sm bg-gray-200 rounded-pill">Rent Avatar</a>&nbsp;
            <a href="#" className="btn btn-lg btn-block lh-18 rajdhani-600 text-gray-900 font-sm bg-gray-200 rounded-pill">Buy Avatar</a>
          </div>
        </div>
      </div>
      <div className="col-lg-4 col-md-4">
        <div className="nft-div border dark-bg3 rounded-10 dark-border p-2 mt-4">
          <div className="d-flex gap-2 p-1">
            <figure className="avater mb-0"><img src="images/artist-3.jpg" alt="user" className="w-35 rounded-pill" /></figure>
            <h5 className="rajdhani-600 text-gray-900 h6 dark-text d-flex lh-34 gap-1">@aditiyasonny <i className="bi-patch-check-fill font-sm text-success mt-1" /></h5>
            <i className="btn btn-icon btn-sm rounded-pill ms-auto dark-text dark-border m-0 border bi-three-dots font-sm" />
          </div>
          <div className="d-flex p-1 posr"><figure className="mb-0 w-100 rounded-10 h-250 bg-image-cover bg-no-repeat bg-image-center" style={{backgroundImage: 'url(images/avatar-2.jpeg)'}} />
          </div>
          <div className="d-flex mt-2 p-1">
            <h2 className="rajdhani-600 text-gray-900 dark-text h5">Gabbar Exomana  <span className="font-xss d-block text-gray-500 rajdhani-600">@panditcoast</span></h2>
            <span className="ms-auto d-flex justify-content-center w-40 h-40 mt-1 bg-gray-100 border rounded-pill"><img src="images/icon-13.png" alt="img" className="w-26 my-auto" /></span>
          </div>
          <div className="d-flex justify-content-between p-1">
            <h6 className="text-start dark-text rajdhani-600"><span className="font-xss rajdhani-500 dark-text text-gray-500 d-block">Current price</span>0.987TRON</h6>
            <h6 className="text-center dark-text rajdhani-600"><span className="font-xss rajdhani-500 text-gray-500 d-block">Floor price</span>2.27TRON</h6>
            <h6 className="text-end dark-text rajdhani-600"><span className="font-xss rajdhani-500 text-gray-500 d-block">Current Bid</span>1.73TRON</h6>
          </div>
          <div className="d-flex p-1">
          <a href="#" className="btn btn-lg btn-block lh-18 rajdhani-600 text-gray-900 font-sm bg-gray-200 rounded-pill">Rent Avatar</a>&nbsp;
            <a href="#" className="btn btn-lg btn-block lh-18 rajdhani-600 text-gray-900 font-sm bg-gray-200 rounded-pill">Buy Avatar</a>
          </div>
        </div>
      </div>
      <div className="col-lg-4 col-md-4">
        <div className="nft-div border dark-bg3 rounded-10 dark-border p-2 mt-4">
          <div className="d-flex gap-2 p-1">
            <figure className="avater mb-0"><img src="images/artist-4.jpg" alt="user" className="w-35 rounded-pill" /></figure>
            <h5 className="rajdhani-600 text-gray-900 h6 dark-text d-flex lh-34 gap-1">@alicehope <i className="bi-patch-check-fill font-sm text-success mt-1" /></h5>
            <i className="btn btn-icon btn-sm rounded-pill ms-auto dark-text dark-border m-0 border bi-three-dots font-sm" />
          </div>
          <div className="d-flex p-1 posr"><figure className="mb-0 w-100 rounded-10 h-250 bg-image-cover bg-no-repeat bg-image-center" style={{backgroundImage: 'url(images/avatar-3.jpeg)'}} />
          </div>
          <div className="d-flex mt-2 p-1">
            <h2 className="rajdhani-600 text-gray-900 dark-text h5">Mainfest Clone  <span className="font-xss d-block text-gray-500 rajdhani-600">@panditcoast</span></h2>
            <span className="ms-auto d-flex justify-content-center w-40 h-40 mt-1 bg-gray-100 border rounded-pill"><img src="images/icon-13.png" alt="img" className="w-26 my-auto" /></span>
          </div>
          <div className="d-flex justify-content-between p-1">
            <h6 className="text-start dark-text rajdhani-600"><span className="font-xss rajdhani-500 dark-text text-gray-500 d-block">Current price</span>0.987TRON</h6>
            <h6 className="text-center dark-text rajdhani-600"><span className="font-xss rajdhani-500 text-gray-500 d-block">Floor price</span>2.27TRON</h6>
            <h6 className="text-end dark-text rajdhani-600"><span className="font-xss rajdhani-500 text-gray-500 d-block">Current Bid</span>1.73TRON</h6>
          </div>
          <div className="d-flex p-1">
          <a href="#" className="btn btn-lg btn-block lh-18 rajdhani-600 text-gray-900 font-sm bg-gray-200 rounded-pill">Rent Avatar</a>&nbsp;
            <a href="#" className="btn btn-lg btn-block lh-18 rajdhani-600 text-gray-900 font-sm bg-gray-200 rounded-pill">Buy Avatar</a>
          </div>
        </div>
      </div>
      <div className="col-lg-4 col-md-4">
        <div className="nft-div border dark-bg3 rounded-10 dark-border p-2 mt-4">
          <div className="d-flex gap-2 p-1">
            <figure className="avater mb-0"><img src="images/artist-1.jpg" alt="user" className="w-35 rounded-pill" /></figure>
            <h5 className="rajdhani-600 text-gray-900 h6 dark-text d-flex lh-34 gap-1">@deoxclub <i className="bi-patch-check-fill font-sm text-success mt-1" /></h5>
            <i className="btn btn-icon btn-sm rounded-pill ms-auto dark-text dark-border m-0 border bi-three-dots font-sm" />
          </div>
          <div className="d-flex p-1 posr"><figure className="mb-0 w-100 rounded-10 h-250 bg-image-cover bg-no-repeat bg-image-center" style={{backgroundImage: 'url(images/avatar-4.jpeg)'}} />
          </div>
          <div className="d-flex mt-2 p-1">
            <h2 className="rajdhani-600 text-gray-900 dark-text h5">Amazonia Stock  <span className="font-xss d-block text-gray-500 rajdhani-600">@panditcoast</span></h2>
            <span className="ms-auto d-flex justify-content-center w-40 h-40 mt-1 bg-gray-100 border rounded-pill"><img src="images/icon-13.png" alt="img" className="w-26 my-auto" /></span>
          </div>
          <div className="d-flex justify-content-between p-1">
            <h6 className="text-start dark-text rajdhani-600"><span className="font-xss rajdhani-500 dark-text text-gray-500 d-block">Current price</span>0.987TRON</h6>
            <h6 className="text-center dark-text rajdhani-600"><span className="font-xss rajdhani-500 text-gray-500 d-block">Floor price</span>2.27TRON</h6>
            <h6 className="text-end dark-text rajdhani-600"><span className="font-xss rajdhani-500 text-gray-500 d-block">Current Bid</span>1.73TRON</h6>
          </div>
          <div className="d-flex p-1">
          <a href="#" className="btn btn-lg btn-block lh-18 rajdhani-600 text-gray-900 font-sm bg-gray-200 rounded-pill">Rent Avatar</a>&nbsp;
            <a href="#" className="btn btn-lg btn-block lh-18 rajdhani-600 text-gray-900 font-sm bg-gray-200 rounded-pill">Buy Avatar</a>
          </div>
        </div>
      </div>
      <div className="col-lg-4 col-md-4">
        <div className="nft-div border dark-bg3 rounded-10 dark-border p-2 mt-4">
          <div className="d-flex gap-2 p-1">
            <figure className="avater mb-0"><img src="images/artist-5.jpg" alt="user" className="w-35 rounded-pill" /></figure>
            <h5 className="rajdhani-600 text-gray-900 h6 dark-text d-flex lh-34 gap-1">@moonbird <i className="bi-patch-check-fill font-sm text-success mt-1" /></h5>
            <i className="btn btn-icon btn-sm rounded-pill ms-auto dark-text dark-border m-0 border bi-three-dots font-sm" />
          </div>
          <div className="d-flex p-1 posr"><figure className="mb-0 w-100 rounded-10 h-250 bg-image-cover bg-no-repeat bg-image-center" style={{backgroundImage: 'url(images/avatar-5.jpeg)'}} />
          </div>
          <div className="d-flex mt-2 p-1">
            <h2 className="rajdhani-600 text-gray-900 dark-text h5">Stork Pass Official  <span className="font-xss d-block text-gray-500 rajdhani-600">@panditcoast</span></h2>
            <span className="ms-auto d-flex justify-content-center w-40 h-40 mt-1 bg-gray-100 border rounded-pill"><img src="images/icon-13.png" alt="img" className="w-26 my-auto" /></span>
          </div>
          <div className="d-flex justify-content-between p-1">
            <h6 className="text-start dark-text rajdhani-600"><span className="font-xss rajdhani-500 dark-text text-gray-500 d-block">Current price</span>0.987TRON</h6>
            <h6 className="text-center dark-text rajdhani-600"><span className="font-xss rajdhani-500 text-gray-500 d-block">Floor price</span>2.27TRON</h6>
            <h6 className="text-end dark-text rajdhani-600"><span className="font-xss rajdhani-500 text-gray-500 d-block">Current Bid</span>1.73TRON</h6>
          </div>
          <div className="d-flex p-1">
          <a href="#" className="btn btn-lg btn-block lh-18 rajdhani-600 text-gray-900 font-sm bg-gray-200 rounded-pill">Rent Avatar</a>&nbsp;
            <a href="#" className="btn btn-lg btn-block lh-18 rajdhani-600 text-gray-900 font-sm bg-gray-200 rounded-pill">Buy Avatar</a>
          </div>
        </div>
      </div>
      <div className="col-lg-4 col-md-4">
        <div className="nft-div border dark-bg3 rounded-10 dark-border p-2 mt-4">
          <div className="d-flex gap-2 p-1">
            <figure className="avater mb-0"><img src="images/artist-6.jpg" alt="user" className="w-35 rounded-pill" /></figure>
            <h5 className="rajdhani-600 text-gray-900 h6 dark-text d-flex lh-34 gap-1">@novitathomson <i className="bi-patch-check-fill font-sm text-success mt-1" /></h5>
            <i className="btn btn-icon btn-sm rounded-pill ms-auto dark-text dark-border m-0 border bi-three-dots font-sm" />
          </div>
          <div className="d-flex p-1 posr"><figure className="mb-0 w-100 rounded-10 h-250 bg-image-cover bg-no-repeat bg-image-center" style={{backgroundImage: 'url(images/avatar-6.jpeg)'}} />
          </div>
          <div className="d-flex mt-2 p-1">
            <h2 className="rajdhani-600 text-gray-900 dark-text h5">Element Standard  <span className="font-xss d-block text-gray-500 rajdhani-600">@panditcoast</span></h2>
            <span className="ms-auto d-flex justify-content-center w-40 h-40 mt-1 bg-gray-100 border rounded-pill"><img src="images/icon-13.png" alt="img" className="w-26 my-auto" /></span>
          </div>
          <div className="d-flex justify-content-between p-1">
            <h6 className="text-start dark-text rajdhani-600"><span className="font-xss rajdhani-500 dark-text text-gray-500 d-block">Current price</span>0.987TRON</h6>
            <h6 className="text-center dark-text rajdhani-600"><span className="font-xss rajdhani-500 text-gray-500 d-block">Floor price</span>2.27TRON</h6>
            <h6 className="text-end dark-text rajdhani-600"><span className="font-xss rajdhani-500 text-gray-500 d-block">Current Bid</span>1.73TRON</h6>
          </div>
          <div className="d-flex p-1">
          <a href="#" className="btn btn-lg btn-block lh-18 rajdhani-600 text-gray-900 font-sm bg-gray-200 rounded-pill">Rent Avatar</a>&nbsp;
            <a href="#" className="btn btn-lg btn-block lh-18 rajdhani-600 text-gray-900 font-sm bg-gray-200 rounded-pill">Buy Avatar</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

  )
}
